
export const SET_EXAM_SELECTED = 'SET_EXAM_SELECTED';
export const SET_EXAMS_STATUS= 'SET_EXAMS_STATUS';
export const SET_HISTORICAL_EXAMS = 'SET_HISTORICAL_EXAMS';
export const SET_LOADING_HISTORICAL_EXAMS = 'SET_LOADING_HISTORICAL_EXAMS';
export const SET_CANCEL_ENROLL = 'SET_CANCEL_ENROLL';
export const SET_ENROLL_PACS = 'SET_ENROLL_PACS';
